import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Typography,
  Grid,
  Button,
  TextField,
} from '@mui/material';
import Search from '@mui/icons-material/Search';
import TTareas from '../GestionDeTareas/TTareas';
import style from '../Tools/Style';
import { obtenerTareasPresupuesto } from '../../actions/TareasAction';
import { useStateValue } from '../../contexto/store';
import { useHistory } from 'react-router-dom';
export function HistorialDeTareasDePresupuesto(props) {
  const mounted = useRef(true);
  const presupuesto = props.location.state;
  const [term, setTerm] = useState('');
  const [rows, setRows] = useState([]);
  const history = useHistory();
  const volver = () => {
    props.history.goBack();
  };
  const nuevaTareaPresupuesto = () => {
    /*RRR:PRESUPUESTOS/TAREA-01 enviamos el presupuesto como estado en el location para que el componente detecte que se trata
      de una tarea a un presupuesto*/
    history.push({ pathname: '/nuevaTarea', state: presupuesto });
  };
  //eslint-disable-next-line
  const [{ sesionUsuario }, dispatch] = useStateValue();
  useEffect(() => {
    if (mounted.current) {
      obtenerTareasPresupuesto(
        sesionUsuario.usuario.id,
        presupuesto.presupuestO_Id
      ).then((response) => {
        if (response.status === 200) {
          setRows(response.data);
        }
      });
    }
    return function cleanup() {
      mounted.current = false;
    };
  }, [sesionUsuario, presupuesto]);
  return (
    <Container maxWidth="lg">
      <br />
      <Typography align="center" variant="h6">
        Historial de Tareas del Presupuesto Nro: {presupuesto.codpresupuesto}
      </Typography>
      <br />
      <Grid container direction="row" justify="flex-start" spacing={3}>
        <Grid item lg={2} md={2} sm={12} xs={12}>
          <Button
            onClick={nuevaTareaPresupuesto}
            variant="contained"
            color="primary"
          >
            Nueva Tarea
          </Button>
        </Grid>
        <Grid item lg={2} md={2} sm={12} xs={12}>
          <Button onClick={volver} variant="contained" color="primary">
            Volver a Presupuestos
          </Button>
        </Grid>
      </Grid>
      <Grid container direction="row">
        <Grid item lg={12} md={12} xs={12} sm={12}>
          <br />
          <Search style={{ fontSize: 40, marginTop: 5 }} />
          <TextField
            style={style.Selectrol}
            variant="outlined"
            onChange={(e) => setTerm(e.target.value)}
            label=" Buscar"
          >
            Buscar
          </TextField>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item lg={12} md={12} sm={12} xs={12}>
          <TTareas
            rows={rows}
            termc={term}
            history={props.history}
            id={presupuesto.TipoVisitante}
          />
        </Grid>
      </Grid>
    </Container>
  );
}
